import React from 'react';
import { Helmet } from 'react-helmet';

const Schema = ({ type, data }) => {
  let schemaData = null;

  if (type === 'organization') {
    schemaData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Pulpit Cabs",
      "url": "https://pulpitcabs.com",
      "logo": "https://pulpitcabs.com/logo512.png",
      "sameAs": [
        "https://www.facebook.com/pulpitcabs",
        "https://twitter.com/pulpitcabs",
        "https://www.instagram.com/pulpitcabs",
        "https://www.linkedin.com/company/pulpitcabs"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-9999999999",
        "contactType": "customer service"
      }
    };
  }

  if (type === 'service' && data) {
    schemaData = {
      "@context": "https://schema.org",
      "@type": "TaxiService",
      "name": data.name || "Cab Service",
      "description": `Reliable and affordable cab service in ${data.city || 'your city'}. Book local or outstation rides.`,
      "provider": {
        "@type": "LocalBusiness",
        "name": "Pulpit Cabs",
        "image": "https://pulpitcabs.com/logo512.png",
        "url": "https://pulpitcabs.com",
        "telephone": "+91-9999999999",
        "priceRange": "₹"
      },
      "areaServed": {
        "@type": "City",
        "name": data.city || "Ahmedabad"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1200"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Cab Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Outstation Cab"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Local Rental"
            }
          }
        ]
      }
    };
  }

  if (type === 'route' && data) {
    schemaData = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": `Cab from ${data.from} to ${data.to}`,
      "description": `Intercity cab service between ${data.from} and ${data.to}. Distance: ${data.distance}km.`,
      "provider": {
        "@type": "LocalBusiness",
        "name": "Pulpit Cabs",
        "image": "https://pulpitcabs.com/logo512.png",
        "url": "https://pulpitcabs.com",
        "telephone": "+91-9999999999",
        "priceRange": `₹${data.price}`
      },
      "offers": {
        "@type": "Offer",
        "price": data.price,
        "priceCurrency": "INR",
        "url": `https://pulpitcabs.com/routes/${data.from.toLowerCase()}-to-${data.to.toLowerCase()}-cab`
      },
      "itinerary": {
        "@type": "City",
        "name": data.from,
        "subTrip": {
          "@type": "City",
          "name": data.to
        }
      }
    };
  }

  if (!schemaData) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default Schema;
